module.exports = __webpack_public_path__ + "img/reporting_posts_numbers.6cb0a065.svg";